import { Currency } from '../../atoms/numberFormatCustom'
import { process } from '../../calcs/fiscalCalculation'
import { exemptLimit } from '../../calcs/incomeTaxCalculation'

function getCookie(name) {
	let cookie = {}
	document.cookie.split(';').forEach(function (el) {
		let [k, v] = el.split('=')
		cookie[k.trim()] = v
	})
	return cookie[name]
}


export function getRDTRKCookie() {
	let decodedCookie = decodeURIComponent(getCookie('rdtrk'))
	try {
		return JSON.parse(decodedCookie)
	} catch (e) {
		return ''
	}
}

const fields = [
	'alimonyYearlyExpenses',
	'averageMedicalYearlyExpenses',
	'grossIncome',
	'ownEducationYearlyExpenses',
	'previdencyYearlyContribution']

const resolveResult = (data) =>{
	const numberedData = fields.reduce((p, c) => {
		p[c] = Number(p[c])
		return p
	}, data)
	let situation =""
	let isCompleteBetter = false
	let simplifiedGain = ""
	let missingPrevidencyValue = ""
	let excessivePrevidencyValue = ""
	let optimizedFiscalGain = ""
	let fiscalGainOverSimplified = ""
	let optimizedFiscalGainOverSimplified = ""
	const result = process(numberedData)

	const maxContribution = (data.grossIncome * 0.12)

	if(numberedData.grossIncome < exemptLimit){
		situation = "Isento"
	} else {
		isCompleteBetter = result.withUserSupplementaryPension.fiscalGainFromSimplified >0
		if(!isCompleteBetter){
			situation = "SimplificadaMelhor"
			simplifiedGain = Math.abs(result.withUserSupplementaryPension.fiscalGainFromSimplified)
		} else {
			optimizedFiscalGainOverSimplified = result.withSupplementaryPensionMaximum.fiscalGainFromSimplified
			fiscalGainOverSimplified = result.withUserSupplementaryPension.fiscalGainFromSimplified
			optimizedFiscalGain =  result.withSupplementaryPensionMaximum.fiscalGainFromUser
			missingPrevidencyValue = (result.withSupplementaryPensionMaximum.supplementaryPensionContribution - result.withUserSupplementaryPension.supplementaryPensionContribution)
			if(data.previdencyYearlyContribution === 0){
				situation = "CompletaMelhorNaoTemPrevidencia"
			} else if(data.previdencyYearlyContribution > 0 && data.previdencyYearlyContribution < maxContribution ){
				situation = "CompletaMelhorPrevidenciaNaoOtimizada"
			} else if(data.previdencyYearlyContribution === maxContribution ){
				situation = "CompletaMelhorPrevidenciaOtimizada"
			} else if (data.previdencyYearlyContribution > maxContribution){
				situation = "CompletaMelhorPrevidenciaEmExcesso"
				excessivePrevidencyValue = (data.previdencyYearlyContribution - maxContribution)
			}
		}
	}

	return {
		result,
		'cf_melhor_declaracao': isCompleteBetter? "completa": "simplificada",
		'cf_planejador_categoria_resultado': situation,
		'cf_planejador_ganho_na_simplificada': Currency(simplifiedGain, 2),
		'cf_planejador_previdencia_faltanto': Currency(missingPrevidencyValue, 2) || "",
		'cf_planejador_previdencia_maxima': Currency(maxContribution, 2) || "",
		'cf_planejador_ganho_fiscal_otimizado': Currency(optimizedFiscalGain, 2) || "",
		'cf_planejador_previdencia_excesso': Currency(excessivePrevidencyValue, 2) || "",
		'cf_planejador_ganho_fiscal_sobre_simplificada': Currency(fiscalGainOverSimplified, 2) || "",
		'cf_planejador_ganho_fiscal_otimizado_sobre_simplificada': Currency(optimizedFiscalGainOverSimplified, 2) || "",
	}
}

export const buildPayload = (data, form, destination = "RD") =>{
	const RDID = getRDTRKCookie().id
	const { result, ...extraFields}  = 	resolveResult(data)

	const shared = {
		'conversion_identifier': 'planejador_imposto_conversion',
		'name': form.name ,
		'email': form.email,
		'personal_phone': form.phone,

		//inputs
		'cf_planejador_dependentes': Currency(data.dependents.length, 2) || "" ,
		'cf_planejador_dependentes_valor_total': Currency(result.withUserSupplementaryPension.dependentsDeduction, 2) || "" ,
		'cf_planejador_despesa_educacao_propria_anual': Currency(data.ownEducationYearlyExpenses, 2) || "" ,
		'cf_planejador_despesas_medicas_anuais': Currency(data.averageMedicalYearlyExpenses, 2) || "" ,
		'cf_planejador_pensao_valor': Currency(data.alimonyYearlyExpenses, 2) || "" ,
		'cf_planejador_previdencia_valor': Currency(data.previdencyYearlyContribution, 2) || "" ,
		'cf_planejador_renda_bruta_anual': Currency(data.grossIncome, 2) || "" ,

		//result
		...extraFields,

		'client_tracking_id': RDID,
		'traffic_source': getCookie('__trf.src'),
	}

	if(destination === "RD"){
		return shared
	}

	return {
		people: {
			"$email": form.email,
			"USER_ID": RDID
		},
		track: {
			...shared,
			"$email": form.email
		}
	}
}


const buildBody = (payload) => {
	return {
		'event_type': 'CONVERSION',
		'event_family': 'CDP',
		payload
	}
}
const headers = new Headers()
headers.append('Content-Type', 'application/json')

export const integrate = (data, form) => {
	const mp = window.mixpanel
	if(mp){
		const { people, track } = buildPayload(data, form, "mixpanel")
		try{
			mp.identify(people.USER_ID)
			mp.people.set(people)
			mp.track("Simulator", track)
		} catch (e){
			console.log(e)
		}
	}
	if(window.fbq){
		window.fbq('trackCustom', 'conversion-lp', {lp: 'previdencia'})
	}

	const RDpayload = buildPayload(data, form, "RD")
	const body = buildBody(RDpayload)

	return fetch('https://api.rd.services/platform/conversions?api_key=3b6d3631990a31fbb9258e39fa4d70e7', {
		method: 'POST',
		headers,
		body: JSON.stringify(body)
	})
}
